// extracted by mini-css-extract-plugin
export var mt0 = "promo-banner-module--mt-0--6d0f2";
export var mt1 = "promo-banner-module--mt-1--66a37";
export var mt2 = "promo-banner-module--mt-2--4f685";
export var mt3 = "promo-banner-module--mt-3--e2fe2";
export var mt4 = "promo-banner-module--mt-4--25945";
export var mt5 = "promo-banner-module--mt-5--282f0";
export var mt6 = "promo-banner-module--mt-6--2fa95";
export var promoBanner = "promo-banner-module--promo-banner--2bc10";
export var promoBanner__closeBtn = "promo-banner-module--promo-banner__close-btn--171c2";
export var promoBanner__closeBtn__icon = "promo-banner-module--promo-banner__close-btn__icon--acc95";
export var promoBanner__content = "promo-banner-module--promo-banner__content--af11f";
export var promoBanner__content__body = "promo-banner-module--promo-banner__content__body--94b4d";